import { useState } from 'react'
import NecBoxFill from '@/components/calc/NecBoxFill'
import AashtoSightDistance from '@/components/calc/AashtoSightDistance'
import MosfetThermal from '@/components/calc/MosfetThermal'
import RailroadTurnout from '@/components/calc/RailroadTurnout'
import PipingFlowCalc from '@/components/calc/PipingFlowCalc'

type TabKey = 'nec' | 'aashto' | 'mosfet' | 'railroad' | 'piping'

const TABS: { key: TabKey; label: string; sub: string; dot: string }[] = [
  { key: 'nec', label: 'NEC Box Fill', sub: 'Electrical · 314.16', dot: 'bg-amber-500' },
  { key: 'aashto', label: 'Sight Distance', sub: 'Road · AASHTO', dot: 'bg-sky-500' },
  { key: 'mosfet', label: 'MOSFET Thermal', sub: 'PCB · Junction Temp', dot: 'bg-rose-500' },
  { key: 'railroad', label: 'Turnout Geometry', sub: 'Railway · Frog Angle', dot: 'bg-emerald-500' },
  { key: 'piping',   label: 'Pipe Junction Loss', sub: 'Fluids · Darcy-Weisbach', dot: 'bg-cyan-500' },
]

export default function CalculatorDashboard() {
  const [tab, setTab] = useState<TabKey>('nec')

  return (
    <section id="calculators" className="mx-auto max-w-7xl px-6 pt-16">
      <div className="flex items-end justify-between gap-4">
        <div>
          <div className="text-xs font-semibold uppercase tracking-widest text-slate-400">Component D</div>
          <h2 className="mt-1 text-2xl font-bold tracking-tight text-slate-900">Live Calculator Sandboxes</h2>
          <p className="mt-1 text-sm text-slate-500">
            Five mathematically exact tools — NEC electrical, AASHTO road, MOSFET thermal, railroad geometry, and piping junction pressure loss.
          </p>
        </div>
      </div>

      <div className="mt-6 rounded-2xl border border-slate-200 bg-white">
        <div className="flex flex-wrap gap-1 border-b border-slate-200 p-2">
          {TABS.map((t) => {
            const active = tab === t.key
            return (
              <button
                key={t.key}
                type="button"
                onClick={() => setTab(t.key)}
                className={`flex flex-1 min-w-[150px] items-center gap-3 rounded-xl px-4 py-3 text-left transition ${
                  active ? 'bg-slate-900 text-white' : 'text-slate-600 hover:bg-slate-50'
                }`}
              >
                <span className={`h-2 w-2 shrink-0 rounded-full ${t.dot}`} />
                <span>
                  <span className="block text-sm font-semibold">{t.label}</span>
                  <span className={`block font-mono text-[11px] ${active ? 'text-slate-300' : 'text-slate-400'}`}>
                    {t.sub}
                  </span>
                </span>
              </button>
            )
          })}
        </div>

        <div className="p-6 sm:p-8">
          {tab === 'nec' ? <NecBoxFill /> : null}
          {tab === 'aashto' ? <AashtoSightDistance /> : null}
          {tab === 'mosfet' ? <MosfetThermal /> : null}
          {tab === 'railroad' ? <RailroadTurnout /> : null}
          {tab === 'piping'   ? <PipingFlowCalc /> : null}
        </div>
      </div>
    </section>
  )
}
